import api from "../../../core/api";
import {
  Team,
  TeamMember,
  TeamLocation,
  TeamWorkload,
  CreateTeam,
  AssignableUser,
} from "../models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.maintenanceApiBaseUrl };
};

class TeamsApi {
  getTeams(locationId?: string): Promise<Team[]> {
    const params = locationId ? `?locationId=${locationId}` : "";
    return api
      .get<Team[]>(`/v1/customer/teams${params}`, getRequestConfig())
      .then(x => x.data);
  }

  getAssignableUsers(locationId?: string): Promise<AssignableUser[]> {
    const params = locationId ? `?locationId=${locationId}` : "";
    return api
      .get<AssignableUser[]>(
        `/v1/customer/teams/assignable-users${params}`,
        getRequestConfig()
      )
      .then(x => x.data);
  }

  getTeam(id: string): Promise<Team> {
    return api
      .get<Team>(`/v1/customer/teams/${id}`, getRequestConfig())
      .then(x => x.data);
  }

  createTeam(model: CreateTeam): Promise<Team> {
    return api
      .post<Team>("/v1/customer/teams", model, getRequestConfig())
      .then(x => x.data);
  }

  updateTeam(id: string, model: CreateTeam): Promise<Team> {
    return api
      .put<Team>(`/v1/customer/teams/${id}`, model, getRequestConfig())
      .then(x => x.data);
  }

  deleteTeam(id: string): Promise<void> {
    return api
      .delete(`/v1/customer/teams/${id}`, getRequestConfig())
      .then(() => undefined);
  }

  addMember(
    teamId: string,
    model: { userId: string; userName: string }
  ): Promise<TeamMember> {
    return api
      .post<TeamMember>(
        `/v1/customer/teams/${teamId}/members`,
        model,
        getRequestConfig()
      )
      .then(x => x.data);
  }

  removeMember(teamId: string, userId: string): Promise<void> {
    return api
      .delete(
        `/v1/customer/teams/${teamId}/members/${userId}`,
        getRequestConfig()
      )
      .then(() => undefined);
  }

  getWorkload(teamId: string): Promise<TeamWorkload> {
    return api
      .get<TeamWorkload>(
        `/v1/customer/teams/${teamId}/workload`,
        getRequestConfig()
      )
      .then(x => x.data);
  }

  getTeamLocations(teamId: string): Promise<TeamLocation[]> {
    return api
      .get<TeamLocation[]>(
        `/v1/customer/teams/${teamId}/locations`,
        getRequestConfig()
      )
      .then(x => x.data);
  }

  updateTeamLocations(teamId: string, locationIds: string[]): Promise<void> {
    return api
      .put(
        `/v1/customer/teams/${teamId}/locations`,
        { locationIds },
        getRequestConfig()
      )
      .then(() => undefined);
  }

  removeTeamLocation(teamId: string, locationId: string): Promise<void> {
    return api
      .delete(
        `/v1/customer/teams/${teamId}/locations/${locationId}`,
        getRequestConfig()
      )
      .then(() => undefined);
  }
}

export default new TeamsApi();
